<div class="market-history">

  <h2 class="heading">
    <i class="ion-md-link text-muted mx-2 align-self-center" style="font-size: 20px; vertical-align: middle;"></i>

    {{"historical-data"|translate}}
    <span class="mx-2"> </span>
    <button (click)="show = !show" mat-icon-button color="primary">
      <mat-icon class="action-button">history</mat-icon>
    </button>
    <button [disabled]="data.length==0" matTooltipPosition="left" matTooltip="{{'export-excel'|translate}}"
      matTooltipClass="custom-tooltip" (click)="exportAsExcel()" mat-icon-button color="primary">
      <mat-icon class="action-button">save_alt</mat-icon>
    </button>
    <span class="widget-reuters" container="body" matTooltipPosition="left" [matTooltip]='companyName'
      matTooltipClass="custom-tooltip" *ngIf="reuters!= null && reuters!=''">
      {{reuters}}
    </span>
  </h2>

  <div class="tab-content">

    <div class="form-bg" style="padding:10px 10px 0px 10px" *ngIf="show" [@enterAnimation]>
      <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>Select Date Range</mat-label>
        <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
          <input matStartDate formControlName="start" placeholder="Start date">
          <input matEndDate formControlName="end" placeholder="End date">
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>

        <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
        <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
      </mat-form-field>
    </div>


    <div [ngStyle]="{'height':(show)?'calc(100% - 66px)':'100%'}">
      <table class="table table-striped">
        <thead *ngIf="data.length>0 && !isDepthLoading">
          <tr style="padding-inline-end: 10px;">
            <th>{{"date"|translate}}</th>
            <th style="min-width: 95px;max-width: 95px;">{{"val&vol"|translate}}</th>
            <th style="min-width: 95px;max-width: 95px;">{{"open&close"|translate}}</th>
            <th style="min-width: 95px;max-width: 95px;">{{"high&low"|translate}}</th>
          </tr>
        </thead>

        <tbody *ngIf="data.length>0 && !isDepthLoading">
          <tr *ngFor="let depth of data; let i = index;"
          [ngStyle]="
          isDarkTheme && i % 2 == 0
            ? { background: '#2a2e39' }
            : { background: '#131722' }
        "
        [ngStyle]="
          !isDarkTheme && i % 2 == 0
            ? { background: 'whitesomke' }
            : { background: '#2A2E39' }
        ">
            <td>{{depth.TRADE_DATE | date}}</td>
            <td style="min-width: 95px;text-align: center;">{{depth.TRADE_VALUE| customNumber}}<br>{{depth.TRADE_VOLUME|
              customNumber}}</td>
            <td style="min-width: 95px;text-align: center;">{{depth.OPEN_PRICE| number}}<br>{{depth.CLOSE_PRICE|
              number}}</td>
            <td style="min-width: 95px;text-align: center;">{{depth.HIGH_PRICE| number}}<br>{{depth.LOW_PRICE| number}}
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="!data[0] && !isDepthLoading">
          <div class="row no-data m-0">
            <div class="col-md-12">
              <img class="empty-state" src="/assets/img/noData.png" />
              <div class="col-sm-12">
                <h6 class="nodata-msg"> {{"select-company-hint"|translate}} </h6>
              </div>
            </div>
          </div>
        </tbody>
        <tbody class="d-flex justify-content-center" *ngIf="isDepthLoading">
          <div class="spinner-border  text-secondary m-5" role="status">
            <span class="sr-only"></span>
          </div>
        </tbody>

      </table>
    </div>

    <div #TABLE style="display: none;">
      <table class="table table-striped">
        <thead *ngIf="data.length>0 && !isDepthLoading">
          <tr style="padding-inline-end: 10px;">
            <th>SYMBOL</th>
            <th>Date</th>
            <th>Value</th>
            <th>Volume</th>
            <th>Open</th>
            <th>Close</th>
            <th>High</th>
            <th>Low</th>
          </tr>
        </thead>
        <tbody *ngIf="data.length>0 && !isDepthLoading">
          <tr *ngFor="let depth of data; let i = index;"
          [ngStyle]="
          isDarkTheme && i % 2 == 0
            ? { background: '#2a2e39' }
            : { background: '#131722' }
        "
        [ngStyle]="
          !isDarkTheme && i % 2 == 0
            ? { background: 'whitesomke' }
            : { background: '#2A2E39' }
        ">>
            <td>{{depth.SYMBOL_CODE}}</td>
            <td>{{depth.TRADE_DATE | date: 'dd/MM/yyyy'}}</td>
            <td>{{depth.TRADE_VALUE| number}}</td>
            <td>{{depth.TRADE_VOLUME| number}}</td>
            <td>{{depth.OPEN_PRICE| number}}</td>
            <td>{{depth.CLOSE_PRICE| number}}</td>
            <td>{{depth.HIGH_PRICE| number}}</td>
            <td>{{depth.LOW_PRICE| number}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</div>
